import React from "react";
import WorkPackageFormData from "./components/WorkPackageFormData";
import WorkPackageTableData from "./components/WorkPackageTableData";

const WorkPackages = ({
  projectInfo,
  setProjectInfo,
  setWorkPackaesInfo,
  workPackagesInfo,
  setTabKey,
  setWpInfo,
  role,
  setShowWpModal,
  showWpModal,
}) => {
  const isWpShowForm = ["superadmin", "assistant superadmin"].includes(role);

  return (
    <div>
      {isWpShowForm && (
        <WorkPackageFormData
          projectInfo={projectInfo}
          workPackagesInfo={workPackagesInfo}
          setWorkPackaesInfo={setWorkPackaesInfo}
          setShowWpModal={setShowWpModal}
          showWpModal={showWpModal}
        />
      )}

      <WorkPackageTableData
        setTabKey={setTabKey}
        projectInfo={projectInfo}
        setWorkPackaesInfo={setWorkPackaesInfo}
        setWpInfo={setWpInfo}
        setProjectInfo={setProjectInfo}
        setShowWpModal={setShowWpModal}
      />
    </div>
  );
};

export default WorkPackages;
